import { useService } from 'react-service-locator';
import { HeaderAction, HeaderActionsService } from 'src/services/header-actions.service';

export function useHeaderActions(): HeaderAction[] {
  const {
    state: { actions },
  } = useService(HeaderActionsService, (s) => [s.state.actions]);
  return actions as HeaderAction[];
}
